import type { DataSourceProvider } from '../../../domains/data-binding/models/DataSource';

interface ConnectedTabularSourceDetails {
  readonly id: string;
  readonly provider: DataSourceProvider;
  readonly name: string;
  readonly config?: Record<string, unknown>;
  readonly sourceTableId?: string | null;
}

export function connectedTabularSourceLabel(
  source: ConnectedTabularSourceDetails | undefined,
  fallback: string,
): string {
  return source?.name || fallback;
}

export function connectedTabularSourceTableId(
  source: ConnectedTabularSourceDetails | undefined,
): string | null {
  if (!source) return null;
  if (source.sourceTableId) return source.sourceTableId;
  const sheetId = typeof source.config?.sheetId === 'string' || typeof source.config?.sheetId === 'number'
    ? String(source.config.sheetId)
    : null;
  const sheetName = typeof source.config?.sheetName === 'string' ? source.config.sheetName : null;
  const worksheetId = typeof source.config?.worksheetId === 'string' ? source.config.worksheetId : null;
  return sheetId ?? sheetName ?? worksheetId ?? null;
}
